import React from "react"
import Modal from "@components/modal"
import BlockHero from "@components/common/blockHero"
import ModalHitosContent from "@components/common/modalHitosContent"
import BlockNumber from "@components/common/blockNumber"
import ChangeModalBtn from "@components/common/changePageBtn"

const Respuesta = () => {
  return (
    <Modal title="MUGARRIAK ETA ESTRATEGIA">
      <div className="mainModal-container">
        <div className="element">
          <BlockHero>
            <div className="title">Erantzun eraginkorra</div>
            <div className="subtitle">osasun-krisiaren aurrean</div>
            <div className="description">
              COVID-19aren pandemiak mutualitatearen jardueran izan zuen
              eraginari aurre egiteko, Mutua Universalek kontingentzia plan
              propio bat eraman zuen aurrera 2020ko ekitaldi osoan zehar, bere
              jarduera eremu guztietan eragina izan zuena.
            </div>
          </BlockHero>
        </div>
        <div className="element">
          <ModalHitosContent>
            <div className="content">
              <div className="title">Jarduteko printzipioak</div>
              <ul>
                <li>
                  <span>Erantzukizuna.</span> Babestutako enpresa eta langileei
                  arreta ematea laguntza zentro propioetan, Osasun Zerbitzu
                  Publikora bidera zitzaten saihesteko eta zerbitzu publikoak
                  gehiegi ez betetzen laguntzeko.
                </li>
                <li>
                  <span>Hurbiltasuna.</span> Jarduteko protokoloen jarraipena
                  egitea eta etengabe egokitzea, autonomia erkidegoetako
                  araudien arabera.
                </li>
                <li>
                  <span>Koordinazioa.</span> Etengabeko lankidetza sektoreko
                  entitateekin eta Administrazioekin (Estatua eta Osasun
                  Sailak), jarduteko politikak, osasun-instalazioak, langileak
                  eta material-horniketa partekatuta.
                </li>
                <li>
                  <span>Elkartasuna.</span> Osasun Zerbitzu Publikoari
                  laguntzea, osasun-instalazioak eta ekipoak Gizarte
                  Segurantzaren eskura ipiniz, uneren batean eskasia gertatuz
                  gero edo gainezka eginez gero.
                </li>
              </ul>
              <div className="description">
                Pandemiaren aurreko kontingentzia planaren hiru helburu zehatzak
                honako hauek izan ziren: Mutua Universaleko langileen taldea
                babestea, laguntzea sistema ez kolapsatzeko eta kutsatzeko
                arriskua saihesteko, eta disrupziorik gabeko operatiboa
                bermatzea.
              </div>
            </div>
            <div className="numbers eraneus">
              <div className="title">PANDEMIA ESPAINIAN (2020)</div>
              <BlockNumber topText="" num="1.928.265" bottomText="kutsatu" />
              <BlockNumber topText="" num="50.837" bottomText="hildako" />
              <BlockNumber
                topText=""
                num="4m"
                bottomText="langile aldi baterako erregulazioko espediente batean egon ziren"
              />
              <BlockNumber
                topText=""
                num="1,4m"
                bottomText="autonomok ezohiko diru-laguntza jaso zuten"
              />
            </div>
          </ModalHitosContent>
        </div>
        <div className="changeBtn">
          <ChangeModalBtn />
        </div>
      </div>
    </Modal>
  )
}

export default Respuesta
